package com.tfc.care.tfccare

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.toComposeImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.viewinterop.InteropView
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.khronos.webgl.*
import org.w3c.dom.HTMLImageElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.Event
import org.w3c.files.Blob
import org.w3c.files.FileReader
import web.html.HTML
import kotlin.js.get
import kotlin.js.length
import kotlin.text.toByte

interface Platform {
    val name: String
}

expect fun getPlatform(): Platform


expect fun copyToClipboard(text: String)

expect suspend fun downloadImageFromUrl(
    imageUrl: String,
    fileName: String
)


@OptIn(ExperimentalJsExport::class)
fun pickImageFromBrowser(
    onPicked: (dynamic) -> Unit  // Changed to dynamic to pass ArrayBuffer
) {
    val input = document.createElement("input") as HTMLInputElement
    input.type = "file"
    input.accept = "image/png,image/jpeg,image/jpg"
    input.multiple = false
    input.onchange = { event: Event ->
        val file = input.files?.item(0)
        if (file != null) {
            val reader = FileReader()
            reader.onload = { loadEvent ->
                val arrayBuffer = reader.result as ArrayBuffer
                onPicked(arrayBuffer)  // Pass ArrayBuffer directly
            }
            reader.readAsArrayBuffer(file)
        }
        Unit
    }
    input.click()
}


